// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__J63JM","hide":"Loader_hide__421YN","spinner":"Loader_spinner__q3d8e","rotate":"Loader_rotate__miUwW"};